import React from 'react';

const EventChip = ({ event, onOpen, variant }) => {
    const open = () => onOpen(event);
    if (variant === 'dot') {
        return (
            <button
                type="button"
                className={`fc-dot tone-${event.tone}${event.selected ? ' is-selected' : ''}`}
                title={event.title}
                aria-label={event.title}
                onClick={(clickEvent) => {
                    clickEvent.stopPropagation();
                    open();
                }}
            />
        );
    }
    return (
        <button
            type="button"
            className={`fc-chip tone-${event.tone}${event.selected ? ' is-selected' : ''}`}
            title={event.title}
            onClick={(clickEvent) => {
                clickEvent.stopPropagation();
                open();
            }}
        >
            {event.title}
        </button>
    );
};

export default EventChip;
